import { Routes, Route } from 'react-router-dom'
import Layout from './components/layout/layout'
import Dashboard from './pages/dashboard'
import SeriesPage from './pages/series'
import SeriesDetailPage from './pages/series-detail'
import SeriesNewPage from './pages/series-new'
import PodcastsPage from './pages/podcasts'
import PodcastEditorPage from './features/podcast-editor/podcast-editor-page'
import BillingPage from './pages/billing'
import VerifyEmailPage from './pages/verify-email'
import EmailVerificationRequiredPage from './pages/email-verification-required'
import SignInPage from './pages/sign-in'
import ProtectedRoute from './components/protected-route'
import PlanAccessRoute from './components/plan-access-route'
import AnalyticsProvider from './components/analytics-provider'
import AdminUsersPage from './pages/admin-users'
import AdminPodcastsPage from './pages/admin-podcasts'
import AdminEmailPage from './pages/admin-email'
import AdminLayout from './components/admin/admin-layout'
import { ToastProvider } from './components/ui/toast-provider'
import UsetifulProvider from './components/usetiful-provider'
import PwaInstallPrompt from './components/pwa-install-prompt'
// import { HeyoConfig } from './components/heyo-config'

function App() {
  return (
    <>
      {/* Provide global analytics, onboarding/help (Usetiful) and toast contexts */}
      <AnalyticsProvider />
      <UsetifulProvider />
      {/* <HeyoConfig /> */}
      <ToastProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/sign-in" element={<SignInPage />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          <Route path="/email-verification-required" element={<EmailVerificationRequiredPage />} />
          {/* Protected routes */}
          <Route path="/*" element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/series" element={<PlanAccessRoute hideFor="legacy"><SeriesPage /></PlanAccessRoute>} />
                  <Route path="/series/new" element={<PlanAccessRoute hideFor="legacy"><SeriesNewPage /></PlanAccessRoute>} />
                  <Route path="/series/:id" element={<PlanAccessRoute hideFor="legacy"><SeriesDetailPage /></PlanAccessRoute>} />
                  <Route path="/podcasts" element={<PlanAccessRoute hideFor="non-legacy"><PodcastsPage /></PlanAccessRoute>} />
                  <Route path="/podcasts/:id" element={<PlanAccessRoute hideFor="non-legacy"><PodcastEditorPage /></PlanAccessRoute>} />
                  <Route path="/billing" element={<BillingPage />} />
                  <Route path="/dashboard/billing" element={<BillingPage />} />
                  <Route path="/admin/*" element={<AdminLayout />}>
                    <Route index element={<AdminUsersPage />} />
                    <Route path="users" element={<AdminUsersPage />} />
                    <Route path="podcasts" element={<AdminPodcastsPage />} />
                    <Route path="email" element={<AdminEmailPage />} />
                  </Route>
                </Routes>
              </Layout>
            </ProtectedRoute>
          } />
        </Routes>
        <PwaInstallPrompt />
      </ToastProvider>
    </>
  )
}

export default App
